// extracted by mini-css-extract-plugin
export default {"text-overflow":"_1JKQg","flex-between":"_1Jnrf","flex-align":"_37fYZ","editable":"_2FX1z","readField":"_1zTDd","editBtn":"_jT90K","confirmBtns":"_2Bgah"};